<script>
    import journal from "../../stores/journal.js";

    export let window;

    const { cairn } = window.props;
    const image = `data:image/svg+xml,${encodeURIComponent(cairn.side)}`;

    const formattedDate = new Date(cairn.created_at).toLocaleDateString(
        "en-US",
        {
            day: "numeric",
            month: "long",
            year: "numeric"
        }
    );

    if (cairn.note) {
        journal.remember(`admired a cairn on the side of the road built by ${cairn.owner} with a note left: ${cairn.note}`)
    } else {
        journal.remember(`admired a cairn on the side of the road built by ${cairn.owner}`)
    }
</script>

<div class="row">
    <div class="side">
        <img src={image} alt="Cairn" />
    </div>

    <div class="info">
        {#if cairn.note}
            <p>“{cairn.note}”, — {cairn.owner}</p>
            <p class="date">{formattedDate}</p>
        {:else}
            <h3>
                {#if cairn.size > 1}
                    {cairn.size} neatly stacked rocks on the&nbsp;side of the&nbsp;road
                {:else}
                    A single rock peacefully lying on the&nbsp;side of
                    the&nbsp;road
                {/if}
            </h3>
            <p>
                Built by {cairn.owner} in {formattedDate}
            </p>
        {/if}
    </div>
</div>

<style>
    .row {
        display: flex;
        align-items: center;
        gap: calc(var(--spacing) * 2);
        box-sizing: border-box;
        padding: calc(var(--spacing) * 2);
        height: 100%;
    }

    .side {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        width: 50%;
        height: 100%;
    }

    img {
        position: relative;
        left: -5px;
        width: auto;
        max-width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .info {
        position: relative;
        width: 50%;
        text-align: center;
    }

    .date {
        opacity: 0.5;
    }
</style>
